import React from 'react'
import { Navigate } from 'react-router-dom'

const PrivateRoute = ({ auth, children }) => {
  return auth.isAuthenticated ? children : <Navigate to='/login' />
}

export default PrivateRoute
